import { PURCHASE_RETURN_REGISTER_REPORT_FAILURE, PURCHASE_RETURN_REGISTER_REPORT_REQUEST, PURCHASE_RETURN_REGISTER_REPORT_SUCCESS, SALES_RETURN_REGISTER_REPORT_FAILURE, SALES_RETURN_REGISTER_REPORT_REQUEST, SALES_RETURN_REGISTER_REPORT_SUCCESS } from "../types";
  
  const initialState = {
    purchaseReturnReports: {},
    loading: false,
    error: null,
  };
  
  const purchaseReturnReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case PURCHASE_RETURN_REGISTER_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case PURCHASE_RETURN_REGISTER_REPORT_SUCCESS: {
        return {
          ...state,
          purchaseReturnRegisterReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PURCHASE_RETURN_REGISTER_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default purchaseReturnReportReducer;
  